import { render } from "./TileButtons.vue?vue&type=template&id=73566961&scoped=true&bindings={\"items\":\"props\"}"
import script from "./TileButtons.vue?vue&type=script&lnag=ts&lang=js"
export * from "./TileButtons.vue?vue&type=script&lnag=ts&lang=js"

import "./TileButtons.vue?vue&type=style&index=0&id=73566961&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73566961"

export default script